import { useCallback, useEffect, useMemo, useState } from 'react';
import { useReduxDispatch, useReduxSelector } from '../../Store/reduxHooks';
import {
  Button,
  Icon,
  Input,
  Select,
  TextArea
} from '../../Universal/NovusDSImports';
import { STRINGS } from '../../Constants/ConstantStrings';
import RightSidePanel from '../../SharedComponets/RightSidePanel';
import dayjs from 'dayjs';
import IPAWSRequestsHistory from './IPAWSRequestsHistory';
import {
  btnStyles,
  inputStyles,
  modalStyles,
  selectStyles
} from '../../Universal/NovusDSImports/variants';
import ApproveOrDisapproveForm from './ApproveOrDisapproveForm';
import ConfirmationPopupModal from '../../SharedComponets/ConfirmationPopupModal';
import {
  getCOGDetails,
  getIPAWSOptionsData,
  requestCancelAlert,
  updateCAPValues
} from '../../Store/reducers/IPAWS';
import { RootState } from '../../store';
import { EventDetailStyles } from './styles';
import { colorState } from '../../Universal/Foundation';
import AdminRequestHistory from './AdminRequestHistory';
import {
  differencefromCurrentTime,
  getPermission,
  validateYupSchema,
  createWeaTextMessageMap
} from '../../CommonUtilities/CommonUtilities';
import axios from 'axios';
import { api_prefix } from '../../Constants/constants';
import FileDownload from 'js-file-download';
import {
  DEV_URL,
  isProdInstance,
  isUatInstance,
  PROD_URL,
  UAT_URL
} from '../../settings';
import * as yup from 'yup';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ClickableLinkAnchor, FormSegment } from '../globalStyles';
import { TooltipComponent } from '../../SharedComponets/Tooltip';

const weaMessageAppendingUrl = isProdInstance
  ? PROD_URL
  : isUatInstance
  ? UAT_URL
  : DEV_URL + '/';

const IPAWSEventDetails = (props: any) => {
  const { onClose } = props;
  const [showIPAWSRequestsHistory, setShowIPAWSRequestsHistory] =
      useState<boolean>(false),
    [showAdminRequestsHistory, setShowAdminRequestsHistory] =
      useState<boolean>(false),
    [isModalOpen, setIsModalOpen] = useState<boolean>(false),
    [isApprove, setIsApprove] = useState<boolean>(false),
    [isConfirmationModalOpen, setIsConfirmationModalOpen] =
      useState<boolean>(false),
    [isEditMode, setIsEditMode] = useState<boolean>(false),
    isRequestInProgress = useReduxSelector(
      (state: RootState) => state.IPAWS.isRequestInProgress
    ),
    currentUser = useReduxSelector(
      (state: RootState) => state.Common.currentUserDetails
    ),
    eventNames = useReduxSelector(
      (state: RootState) => state.Closures.eventNames
    ),
    selectedClosure = useReduxSelector(
      (state: RootState) => state.Common.selectedClosure
    ),
    isFetchingIPAWSOptionsData = useReduxSelector(
      (state: RootState) => state.IPAWS.isFetchingIPAWSOptionsData
    ),
    IPAWSOptionsData = useReduxSelector(
      (state: RootState) => state.IPAWS.IPAWSOptionsData
    ),
    cogDetails = useReduxSelector((state: RootState) => state.IPAWS.cogDetails),
    isFetchingCOGDetails = useReduxSelector(
      (state: RootState) => state.IPAWS.isFetchingCOGDetails
    ),
    eventMaintainers = useReduxSelector(
      (state: RootState) => state.Closures.eventMaintainers
    ),
    [weaHandlingValue, setWeahandlingValue] = useState<string>(
      selectedClosure?.['wea_heandling']
    ),
    [isWeaHandlingChanged, setIsWeaHandlingChanged] = useState<boolean>(false),
    dispatch = useReduxDispatch();

  const weaPrefillTexts = useMemo(() => {
    return createWeaTextMessageMap(eventMaintainers);
  }, [eventMaintainers]);
  const [disapprovalComments, setDisapprovalComments] = useState<Array<any>>(
    []
  );

  useEffect(() => {
    if (selectedClosure) {
      const closure_comments = selectedClosure?.closure_ipaws_comments;
      setDisapprovalComments(() => {
        return closure_comments?.length > 1
          ? [...closure_comments].sort((a: any, b: any) => b.id - a.id)
          : closure_comments;
      });
    }
  }, [selectedClosure]);

  const [viewDisapprovalHistory, setViewDisapprovalHistory] =
    useState<boolean>(false);

  const isSubmittingIPAWS = useReduxSelector(
    (state) => state.IPAWS.isSubmittingIPAWS
  );

  const alertStatusOptions = {
    not_submitted: 'Not Submitted',
    pending_review: 'Pending Review',
    approved: 'Approved',
    disapproved: 'Disapproved',
    cancelled: 'Cancelled'
  };

  const IPAWSOptionTypes = {
    'Event Category': 'event_type',
    Event: 'event',
    Urgency: 'urgency',
    Severity: 'severity',
    Certainty: 'certainity',
    'WEA Handling': 'wea_heandling'
  };

  const customConfirmationStyles = {
    content: {
      minWidth: '20%',
      minHeight: '10vh'
    },
    overlay: {
      backgroundColor: 'rgba(114, 114, 114, 0.294)'
    }
  };

  const customAdminHistoryStyles = {
    content: {
      maxWidth: '50%',
      maxHeight: '60%'
    },
    overlay: {
      backgroundColor: 'rgba(114, 114, 114, 0.294)'
    }
  };

  const customStyles = {
    content: {
      maxWidth: '60%',
      maxHeight: '60%'
    }
  };

  const EditableFields = [
    STRINGS.EVENT_CATEGORY,
    STRINGS.EVENT,
    STRINGS.URGENCY,
    STRINGS.SEVERITY,
    STRINGS.CERTAINITY,
    STRINGS.WEA_HANDLING
  ];

  const TextAreaFields = [
    STRINGS.CMAM_WEA_TEXT,
    STRINGS.CMAM_WEA_LONG_TEXT,
    STRINGS.CMAM_SPANISH_WEA_TEXT,
    STRINGS.CMAM_SPANISH_WEA_LONG_TEXT
  ];

  useEffect(() => {
    if (selectedClosure) {
      dispatch(getCOGDetails({}));
      dispatch(getIPAWSOptionsData({}));
    }
  }, [selectedClosure]);

  const getEventTypeOptions = useCallback(() => {
    const options: any = [];
    eventNames?.forEach((option: any) => {
      options.push({ label: option.name, value: option.id });
    });
    return options;
  }, [eventNames]);

  const getEventType = (id: number, isOption: boolean) => {
    let option: any = null;
    getEventTypeOptions()?.forEach((event: any) => {
      if (event.value === id) {
        option = event;
      }
    });
    return isOption ? option : option?.label;
  };

  const getOptions = useCallback(
    (type: string) => {
      const options: any = [];
      let optionsRawData: any;
      switch (type) {
        case 'WEA Handling':
          optionsRawData =
            IPAWSOptionsData?.['wea_heandling'] &&
            Object.keys(IPAWSOptionsData?.['wea_heandling']);
          break;
        case 'Event':
          optionsRawData =
            IPAWSOptionsData?.['wea_heandling']?.[weaHandlingValue];
          break;
        default:
          optionsRawData = IPAWSOptionsData?.[IPAWSOptionTypes[type]];
      }
      optionsRawData?.forEach((option: any, index: number) => {
        options.push({ label: option, value: index });
      });
      return options;
    },
    [IPAWSOptionsData, weaHandlingValue]
  );

  const getSelectedOption = (type: string) => {
    let option: any;
    getOptions(type)?.forEach((item: any) => {
      if (item.label === selectedClosure[IPAWSOptionTypes[type]]) {
        option = item;
      }
    });
    return option;
  };

  const getDefaultValues = useCallback(() => {
    const dict = {
      event_type: getEventType(selectedClosure?.event_type, true),
      event: getSelectedOption(STRINGS.EVENT),
      urgency: getSelectedOption(STRINGS.URGENCY),
      certainity: getSelectedOption(STRINGS.CERTAINITY),
      severity: getSelectedOption(STRINGS.SEVERITY),
      wea_heandling: getSelectedOption(STRINGS.WEA_HANDLING)
    };
    return dict;
  }, [IPAWSOptionsData, getSelectedOption, selectedClosure]);

  const schema = yup.object().shape({
    event_type: validateYupSchema('select', STRINGS.YUP.EVENT_CATEGORY, true),
    wea_heandling: validateYupSchema('select', STRINGS.YUP.WEA_HANDLING, true),
    event: validateYupSchema('select', STRINGS.YUP.EVENT, true),
    urgency: validateYupSchema('select', STRINGS.YUP.URGENCY, true),
    severity: validateYupSchema('select', STRINGS.YUP.SEVERITY, true),
    certainity: validateYupSchema('select', STRINGS.YUP.CERTAINITY, true)
  });

  const methods = useForm({
    defaultValues: getDefaultValues(),
    resolver: yupResolver(schema)
  });

  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    formState: { dirtyFields, errors }
  } = methods;

  const watchWeaHandling = watch('wea_heandling');

  useEffect(() => {
    if (dirtyFields['wea_heandling'] && !isWeaHandlingChanged) {
      setIsWeaHandlingChanged(true);
    }
  }, [dirtyFields.wea_heandling]);

  useEffect(() => {
    if (isWeaHandlingChanged) {
      setWeahandlingValue(watchWeaHandling?.label);
      setValue('event', null);
    }
  }, [watchWeaHandling, isWeaHandlingChanged]);

  useEffect(() => {
    setViewDisapprovalHistory(false);
  }, [selectedClosure]);

  useEffect(() => {
    if (selectedClosure) {
      setIsEditMode(false);
      setWeahandlingValue(selectedClosure?.['wea_heandling']);
    }
  }, [reset, selectedClosure]);

  useEffect(() => {
    if (isEditMode) {
      reset(getDefaultValues());
      setIsWeaHandlingChanged(false);
    }
  }, [isEditMode]);

  const onSubmit = (data: any) => {
    const payload = { id: selectedClosure?.id };
    Object.keys(data).forEach((param: any) => {
      if (param === 'event_type') payload[param] = data[param]?.value;
      else payload[param] = data[param]?.label;
    });
    dispatch(updateCAPValues({ params: payload }));
    setIsEditMode(false);
  };

  const getCMAMWeaText = (isEnglish: boolean) => {
    return selectedClosure?.status?.name === 'Two-Way Communications (Open)'
      ? `${isEnglish ? 'Go to ' : 'Ir a '}` + weaMessageAppendingUrl
      : '';
  };

  const [secondsLeft, setSecondsLeft] = useState<number>(0);
  const [eventOptions, setEventOptions] = useState<any>({});

  useEffect(() => {
    if (selectedClosure?.alert_expiry) {
      const diffInSeconds = differencefromCurrentTime(
        selectedClosure?.alert_expiry,
        'seconds'
      );

      setSecondsLeft(diffInSeconds);
    }
  }, [selectedClosure]);

  const eventDetailsData = [
    {
      heading: `${STRINGS.EVENT}#`,
      description: selectedClosure?.event_id
    },
    {
      heading: STRINGS.CREATED_BY,
      description: selectedClosure?.created_by?.fullname
    },
    {
      heading: STRINGS.CMAM_WEA_TEXT,
      description: `${selectedClosure?.wea_short_msg_english} ${getCMAMWeaText(
        true
      )}`
    },
    {
      heading: STRINGS.CMAM_WEA_LONG_TEXT,
      description: `${selectedClosure?.wea_long_msg_english} ${getCMAMWeaText(
        true
      )}`
    },
    {
      heading: STRINGS.CMAM_SPANISH_WEA_TEXT,
      description:
        selectedClosure?.wea_short_msg_spanish?.length >
        weaPrefillTexts[selectedClosure?.maintained_by]?.length
          ? `${selectedClosure?.wea_short_msg_spanish} ${getCMAMWeaText(false)}`
          : 'N/A'
    },
    {
      heading: STRINGS.CMAM_SPANISH_WEA_LONG_TEXT,
      description:
        selectedClosure?.wea_long_msg_spanish?.length >
        weaPrefillTexts[selectedClosure?.maintained_by]?.length
          ? ` ${selectedClosure?.wea_long_msg_spanish} ${getCMAMWeaText(false)}`
          : 'N/A'
    },
    {
      heading: STRINGS.DESCRIPTION,
      description: selectedClosure?.description
    },
    {
      heading: STRINGS.JURISDICTIONS_AFFECTED,
      description: selectedClosure?.jurisdictions
    },
    {
      heading: STRINGS.ALERT_DURATION_HOUR_S,
      description: selectedClosure?.alert_duration
    },
    {
      heading: STRINGS.EVENT_CATEGORY,
      description: getEventType(selectedClosure?.event_type, false)
    },
    {
      heading: STRINGS.WEA_HANDLING,
      description: selectedClosure?.wea_heandling
    },
    {
      heading: STRINGS.EVENT,
      description: selectedClosure?.event
    },
    {
      heading: STRINGS.URGENCY,
      description: selectedClosure?.urgency
    },
    {
      heading: STRINGS.SEVERITY,
      description: selectedClosure?.severity
    },
    {
      heading: STRINGS.CERTAINITY,
      description: selectedClosure?.certainity
    },
    {
      heading: STRINGS.INCIDENT_STATUS,
      description: selectedClosure?.status?.name
    },
    {
      heading: STRINGS.LAST_UPDATED,
      description: dayjs(selectedClosure?.modified).format('MM/DD/YYYY hh:mm A')
    },
    {
      heading: STRINGS.REQUESTED_ALERT_TYPE,
      description: selectedClosure?.requested_alert_type
    },
    {
      heading: STRINGS.REQUESTED_BY,
      description: selectedClosure?.last_updated_by?.fullname
    },
    {
      heading: STRINGS.ALERT_STATUS,
      description: alertStatusOptions[selectedClosure?.alert_status]
    }
  ];

  useEffect(() => {
    if (eventDetailsData && isEditMode) {
      const options = {};

      EditableFields.forEach((item) => {
        if (item === 'Event Category') {
          options[item] = getEventTypeOptions();
        } else {
          options[item] = getOptions(item);
        }
      });

      setEventOptions(options);
    }
  }, [isEditMode, weaHandlingValue]);

  const sectionBody = () => {
    return (
      <EventDetailStyles>
        <FormProvider {...methods}>
          <FormSegment
            onSubmit={handleSubmit(onSubmit)}
            onKeyDown={(e) => {
              if (
                e.key === 'Enter' &&
                (e.target as HTMLElement).tagName !== 'BUTTON'
              )
                e.preventDefault();
            }}
          >
            {!isEditMode &&
              selectedClosure?.alert_status === 'pending_review' && (
                <div className="event-details-edit">
                  <p className="d-flex align-items-center justify-content-center gap-2">
                    <h1 className="pe-3">{STRINGS.EDIT_EVENT_DETAILS}</h1>
                    <Button
                      {...btnStyles.secondary}
                      data-testid="edit-event-details-button"
                      className="px-2"
                      onClick={() => setIsEditMode(true)}
                    >
                      <Icon
                        icon={'edit_02'}
                        width={'16px'}
                        height={'16px'}
                        stroke={`${colorState.icon.brand.primary}`}
                      />
                      {STRINGS.EDIT}
                    </Button>
                  </p>
                </div>
              )}
            <div className="event-details-wrapper">
              {eventDetailsData.map((item, index: number) => {
                if (isEditMode) {
                  return EditableFields.includes(item.heading) ? (
                    <Controller
                      name={IPAWSOptionTypes[item.heading]}
                      control={control}
                      render={({ field }) => {
                        return (
                          <Select
                            displayName={item.heading}
                            placeHolder={
                              isFetchingIPAWSOptionsData
                                ? STRINGS.LOADING
                                : STRINGS.SELECT_OPTION
                            }
                            {...field}
                            options={eventOptions[item.heading]}
                            isSearchable={false}
                            asterisk={true}
                            error={errors?.[IPAWSOptionTypes[item.heading]]}
                            hintText={
                              errors?.[IPAWSOptionTypes[item.heading]]?.message
                            }
                            aria-label={`select ${item.heading}`}
                            {...selectStyles}
                          />
                        );
                      }}
                    />
                  ) : TextAreaFields?.includes(item.heading) ? (
                    <TextArea
                      label={item.heading}
                      type="text"
                      isMargin={false}
                      readOnly
                      aria-label={item.description}
                      value={item.description}
                      {...inputStyles}
                    />
                  ) : (
                    <Input
                      label={item.heading}
                      data-testid={item.heading}
                      type="text"
                      isMargin={false}
                      value={item.description}
                      readOnly
                      aria-label={item.description}
                      {...inputStyles}
                    />
                  );
                }
                return (
                  <div className="event-details-data" key={index}>
                    <h1 role="presentation">{item.heading}</h1>
                    <p role="presentation">{item.description}</p>

                    {item.heading === STRINGS.ALERT_STATUS &&
                      item.description === 'Disapproved' &&
                      disapprovalComments.length && (
                        <>
                          <div className="disapproved-messages">
                            Reason:{' '}
                            <span className="comment">
                              {disapprovalComments[0].comment}
                            </span>
                          </div>

                          {!viewDisapprovalHistory &&
                          disapprovalComments.length > 1 ? (
                            <>
                              <ClickableLinkAnchor
                                data-tooltip-id="view_event_history"
                                type="button"
                                className="clickable-link"
                                onClick={() => setViewDisapprovalHistory(true)}
                              >
                                {STRINGS.VIEW_HISTORY}
                              </ClickableLinkAnchor>
                              <TooltipComponent
                                id={`view_event_history`}
                                place="bottom-start"
                              >
                                {STRINGS.VIEW_HISTORY}
                              </TooltipComponent>
                            </>
                          ) : (
                            <>
                              {disapprovalComments.map((comment, index) => {
                                if (index === 0) return null;

                                return (
                                  <div
                                    key={index}
                                    className="disapproved-messages"
                                  >
                                    <p className="disapproval-time">
                                      Last Updated on{' '}
                                      {dayjs(comment.created).format(
                                        'MM/DD/YYYY hh:mm A'
                                      )}
                                    </p>
                                    Reason:{' '}
                                    <span className="comment">
                                      {comment.comment}
                                    </span>
                                  </div>
                                );
                              })}
                            </>
                          )}
                        </>
                      )}
                  </div>
                );
              })}
              <div className="clickable-links">
                {getPermission(currentUser, 'download_situation_report') && (
                  <>
                    <ClickableLinkAnchor
                      data-tooltip-id="download_situation_report"
                      type="button"
                      onClick={async () => {
                        await axios
                          .get(
                            `${api_prefix}closures/${selectedClosure?.id}/get_situation_report/`,
                            { responseType: 'blob' }
                          )
                          .then((response) => {
                            FileDownload(
                              response.data,
                              `SituationReport_${
                                selectedClosure?.id
                              }_${dayjs().format('YYYYMMDDHHmmss')}.pdf`
                            );
                          });
                      }}
                    >
                      {STRINGS.SITREP}
                      <Icon
                        icon="file_06"
                        width={16}
                        height={16}
                        stroke={colorState.icon.info['primary-strong']}
                        className="cursor-pointer ms-1"
                      />
                    </ClickableLinkAnchor>
                    <TooltipComponent
                      id={`download_situation_report`}
                      place="bottom-start"
                    >
                      {STRINGS.DOWNLOAD_SITUATION_REPORT}
                    </TooltipComponent>
                  </>
                )}
                <>
                  <ClickableLinkAnchor
                    type="button"
                    onClick={() => setShowIPAWSRequestsHistory(true)}
                    data-testid="ipaws-requests-history-button"
                    tabIndex={0}
                    data-tooltip-id={`ipaws-requests-history-button`}
                    onKeyDown={(e: any) => {
                      if (e.key === 'Enter') {
                        setShowIPAWSRequestsHistory(true);
                      }
                    }}
                  >
                    {STRINGS.IPAWS_REQUESTS_HISTORY}
                  </ClickableLinkAnchor>
                  <TooltipComponent
                    id={`ipaws-requests-history-button`}
                    place="bottom-start"
                  >
                    {STRINGS.VIEW_IPAWS_REQUEST_HISTORY}
                  </TooltipComponent>
                </>
                {(selectedClosure?.alert_status !== 'pending_review' ||
                  selectedClosure?.alert_status !== 'not_submitted') && (
                  <>
                    <ClickableLinkAnchor
                      type="button"
                      onClick={() => setShowAdminRequestsHistory(true)}
                      data-testid="admin-requests-history-button"
                      tabIndex={0}
                      data-tooltip-id={`admin-requests-history-button`}
                      onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                          setShowAdminRequestsHistory(true);
                        }
                      }}
                    >
                      {STRINGS.ADMIN_REQUEST_HISTORY}
                    </ClickableLinkAnchor>
                    <TooltipComponent
                      id={`admin-requests-history-button`}
                      place="bottom-start"
                    >
                      {STRINGS.VIEW_ADMIN_REQUEST_HISTORY}
                    </TooltipComponent>
                  </>
                )}
              </div>
            </div>
            {selectedClosure?.alert_status === 'pending_review' &&
            selectedClosure.alert_duration ? (
              <div className="footer">
                {isEditMode ? (
                  <>
                    <Button
                      data-testid="cancel-event-details-button"
                      onClick={(e: any) => {
                        e.preventDefault();
                        setIsEditMode(false);
                        setWeahandlingValue(selectedClosure?.wea_heandling);
                      }}
                      {...btnStyles.secondary}
                    >
                      {STRINGS.CANCEL}
                    </Button>
                    <Button
                      data-testid="save-event-details-button"
                      type="submit"
                      {...btnStyles.primary}
                    >
                      {STRINGS.SAVE}
                    </Button>
                  </>
                ) : (
                  <>
                    {getPermission(currentUser, 'decline_ipaws_alert') && (
                      <Button
                        data-testid="disapprove-button"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setIsModalOpen(true);
                        }}
                        {...btnStyles.warningSecondary}
                      >
                        {STRINGS.DISAPPROVE}
                      </Button>
                    )}
                    {getPermission(currentUser, 'approve_ipaws_alert') && (
                      <Button
                        data-testid="approve-button"
                        onClick={(e: any) => {
                          e.preventDefault();
                          setIsApprove(true);
                          setIsModalOpen(true);
                        }}
                        disabled={
                          isFetchingCOGDetails ||
                          cogDetails?.connection_status !== 'Connected'
                        }
                        aria-disabled={
                          isFetchingCOGDetails ||
                          cogDetails?.connection_status !== 'Connected'
                        }
                        {...btnStyles.primary}
                      >
                        {STRINGS.APPROVE}
                      </Button>
                    )}
                  </>
                )}
              </div>
            ) : null}
            {!isEditMode && selectedClosure?.alert_status === 'approved' && (
              <div className="footer">
                <Button
                  data-testid="cancel-approved-event-button"
                  onClick={(e: any) => {
                    e.preventDefault();
                    setIsConfirmationModalOpen(true);
                  }}
                  disabled={isRequestInProgress || secondsLeft <= 0}
                  aria-disabled={isRequestInProgress || secondsLeft <= 0}
                  {...btnStyles.primary}
                >
                  {STRINGS.CANCEL_WEA}
                </Button>
              </div>
            )}
          </FormSegment>
        </FormProvider>
      </EventDetailStyles>
    );
  };

  const handleCloseConfirm = () => {
    dispatch(
      requestCancelAlert({
        closureId: selectedClosure?.id,
        onComplete: () => {
          onClose();
          setIsConfirmationModalOpen(false);
        }
      })
    );
  };

  const renderFooter = () => {
    return (
      <div className="footer">
        <Button
          onClick={() => setIsConfirmationModalOpen(false)}
          data-testid="cancel-approved-event-cancel-button"
          disabled={isSubmittingIPAWS}
          aria-disabled={isSubmittingIPAWS}
          {...btnStyles.default}
        >
          {STRINGS.CANCEL}
        </Button>
        <Button
          data-testid="cancel-approved-event-confirm-button"
          onClick={handleCloseConfirm}
          disabled={isSubmittingIPAWS}
          aria-disabled={isSubmittingIPAWS}
          {...btnStyles.danger}
        >
          {isSubmittingIPAWS ? STRINGS.IN_PROGRESS : STRINGS.CONFIRM}
        </Button>
      </div>
    );
  };

  useEffect(() => {
    const element = document.getElementById(Object.keys(errors)[0]);
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }, [errors]);

  return (
    <>
      <RightSidePanel
        header={STRINGS.EVENT_DETAILS}
        body={sectionBody()}
        onClose={onClose}
      />
      <IPAWSRequestsHistory
        isBodyPaddingNone={true}
        isOpen={showIPAWSRequestsHistory}
        postModalClose={() => setShowIPAWSRequestsHistory(false)}
        closeModal={() => setShowIPAWSRequestsHistory(false)}
        selectedClosure={selectedClosure}
        showHeader={true}
        title={`${STRINGS.IPAWS_REQUESTS_HISTORY_FOR} "${selectedClosure?.wea_short_msg_english}"`}
        {...modalStyles}
        style={customStyles}
      />
      <AdminRequestHistory
        isBodyPaddingNone
        isOpen={showAdminRequestsHistory}
        title={STRINGS.ADMIN_REQUEST_HISTORY}
        selectedClosure={selectedClosure}
        showHeader={true}
        getEventType={getEventType}
        alertStatusOptions={alertStatusOptions}
        disapprovalComments={disapprovalComments}
        postModalClose={() => setShowAdminRequestsHistory(false)}
        closeModal={() => setShowAdminRequestsHistory(false)}
        setShowAdminRequestsHistory={setShowAdminRequestsHistory}
        {...modalStyles}
        style={customAdminHistoryStyles}
      />
      {isModalOpen && (
        <ApproveOrDisapproveForm
          isBodyPaddingNone
          isApprove={isApprove}
          isOpen={isModalOpen}
          shouldCloseOnEsc={isSubmittingIPAWS}
          closeBtnDisabled={isSubmittingIPAWS}
          showHeader={true}
          title={
            isApprove
              ? STRINGS.FORM_APPROVAL_DETAILS
              : STRINGS.DISAPPROVE_CONFIRMATION
          }
          closeModal={() => {
            setIsApprove(false);
            setIsModalOpen(false);
          }}
          selectedClosure={selectedClosure}
          onClose={onClose}
          {...modalStyles}
          style={customStyles}
        />
      )}
      <ConfirmationPopupModal
        isOpen={isConfirmationModalOpen}
        showHeader={false}
        showFooter={false}
        style={customConfirmationStyles}
        closeModal={() => setIsConfirmationModalOpen(false)}
        showBorderTop={false}
        isBodyPaddingNone={true}
        description={'Are you sure you want to cancel this IPAWS alert?'}
        handleCloseConfirm={handleCloseConfirm}
        customFooter={renderFooter()}
      />
    </>
  );
};

export default IPAWSEventDetails;
